import { useState, useEffect, useCallback, createContext, useContext, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

// Pages
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import TrialBanner from "./components/TrialBanner";
import UpgradePage from "./components/UpgradePage";
import Dashboard from "./pages/Dashboard";
import CAPAPage from "./pages/CAPAPage";
import AuditsPage from "./pages/AuditsPage";
import DocumentsPage from "./pages/DocumentsPage";
import TrainingPage from "./pages/TrainingPage";
import SuppliersPage from "./pages/SuppliersPage";
import DeviationsPage from "./pages/DeviationsPage";
import ReportsPage from "./pages/ReportsPage";
import UsersPage from "./pages/UsersPage";
import ProjectsPage from "./pages/ProjectsPage";
import DynamicFormsPage from "./pages/DynamicFormsPage";
import KnowledgeCenterPage from "./pages/KnowledgeCenterPage";
import CalculatorsPage from "./pages/CalculatorsPage";
import V11CalculatorsPage from "./pages/V11CalculatorsPage";
import DispatchReadinessPage from "./pages/DispatchReadinessPage";
import SecurityAuditLogsPage from "./pages/SecurityAuditLogsPage";
import AuditExplorerPage from "./pages/AuditExplorerPage";
import TrialFunnelPage from "./pages/TrialFunnelPage";
import ServiceTokensPage from "./pages/ServiceTokensPage";
import AuditWorkflowPage from "./pages/AuditWorkflowPage";
import ClientQuestionnairePage from "./pages/ClientQuestionnairePage";
import ClientPortalPage from "./pages/ClientPortalPage";
import GanttChartPage from "./pages/GanttChartPage";
import GapAssessmentPage from "./pages/GapAssessmentPage";
import AuditReadinessPage from "./pages/AuditReadinessPage";
import ProjectClosurePage from "./pages/ProjectClosurePage";
import ClientDocumentsPage from "./pages/ClientDocumentsPage";
import AuditMatricesPage from "./pages/AuditMatricesPage";
import QualityAgreementPage from "./pages/QualityAgreementPage";
import CompetitorAnalysisPage from "./pages/CompetitorAnalysisPage";
import MessagesPage from "./pages/MessagesPage";
import AuditLogPage from "./pages/AuditLogPage";
import ContactsPage from "./pages/ContactsPage";
import CommunicationsPage from "./pages/CommunicationsPage";
import TrendAnalysisPage from "./pages/TrendAnalysisPage";
import ProcessCapturePage from "./pages/ProcessCapturePage";
import NotificationSettingsPage from "./pages/NotificationSettingsPage";
import NotificationLogPage from "./pages/NotificationLogPage";
import EnterpriseSSOPage from "./pages/EnterpriseSSOPage";
import SSOOnboardingWizard from "./pages/SSOOnboardingWizard";
import ConnectorsPage from "./pages/ConnectorsPage";
import ImprovementPage from "./pages/ImprovementPage";
import SentinelPage from "./pages/SentinelPage";
import AuditWarRoomPage from "./pages/AuditWarRoomPage";
import ReportLoaderPage from "./pages/ReportLoaderPage";
import DefenseScriptPage from "./pages/DefenseScriptPage";
import StatExplainerPage from "./pages/StatExplainerPage";
import SDVRPage from "./pages/SDVRPage";
import LifecyclePage from "./pages/LifecyclePage";
import AuditorsBrainPage from "./pages/AuditorsBrainPage";
import PublishingPortalPage from "./pages/PublishingPortalPage";
import EBookReaderPage from "./pages/EBookReaderPage";
import CAPAPreventionPage from "./pages/CAPAPreventionPage";
import RegulatoryRadarPage from "./pages/RegulatoryRadarPage";
import ReaderHubLandingPage from "./pages/ReaderHubLandingPage";
import ReaderDashboardPage from "./pages/ReaderDashboardPage";
import AdminCodeGeneratorPage from "./pages/AdminCodeGeneratorPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import QAEnginePage from "./pages/QAEnginePage";
import AboutSeriesPage from "./pages/AboutSeriesPage";
import KnowledgeBasePage from "./pages/KnowledgeBasePage";
import ScriberPage from "./pages/ScriberPage";
import LabsPage from "./pages/LabsPage";
import WarRoomPage from "./pages/WarRoomPage";
import AdminQRCodesPage from "./pages/AdminQRCodesPage";
import ComplianceNavigatorPage from "./pages/ComplianceNavigatorPage";
import DocumentBridgePage from "./pages/DocumentBridgePage";
import SCARManagementPage from "./pages/SCARManagementPage";
import SupplierScorecardPage from "./pages/SupplierScorecardPage";
import AuditConductorPage from "./pages/AuditConductorPage";
import RedactionPage from "./pages/RedactionPage";
import ScriberDisclosuresPage from "./pages/ScriberDisclosuresPage";
import SSOProvidersPage from "./pages/SSOProvidersPage";
import ClientTypesPage from "./pages/ClientTypesPage";
import VendorRegistrationPage from "./pages/VendorRegistrationPage";
import AnalyticsChartsPage from "./pages/AnalyticsChartsPage";
import SCARescalationPage from "./pages/SCARescalationPage";
import ComplianceDashboardPage from "./pages/ComplianceDashboardPage";
import StandardsPortalPage from "./pages/StandardsPortalPage";
import SoAMatrixPage from "./pages/SoAMatrixPage";
import GovernanceCenterPage from "./pages/GovernanceCenterPage";
import GovernanceDocumentPage from "./pages/GovernanceDocumentPage";
import GovernanceControlsPage from "./pages/GovernanceControlsPage";
import RegionalObligationsPage from "./pages/RegionalObligationsPage";
import TrustCenterPage from "./pages/TrustCenterPage";
import GlobalGovernanceAssessmentPage from "./pages/GlobalGovernanceAssessmentPage";
import RemediationTrackerPage from "./pages/RemediationTrackerPage";
import GovernanceReadinessPage from "./pages/GovernanceReadinessPage";
import GovernanceLibraryPage from "./pages/GovernanceLibraryPage";
import OnboardingChecklistPage from "./pages/OnboardingChecklistPage";
import ClientOnboardingDashboardPage from "./pages/ClientOnboardingDashboardPage";
import ClientOnboardingReviewPage from "./pages/ClientOnboardingReviewPage";
import NotificationsPage from "./pages/NotificationsPage";
import QASupervisorPage from "./pages/QASupervisorPage";
import GuidePage from "./pages/GuidePage";
import CRMOrganizationsPage from "./pages/CRMOrganizationsPage";
import CRMOrganizationDetailPage from "./pages/CRMOrganizationDetailPage";
import SupportTicketsPage from "./pages/SupportTicketsPage";
import MySupportPage from "./pages/MySupportPage";
import PredictiveIntelligencePage from "./pages/PredictiveIntelligencePage";
import Annex11ReadinessPage from "./pages/Annex11ReadinessPage";
import PaymentsPage from "./pages/PaymentsPage";
import PlatformHealthPage from "./pages/PlatformHealthPage";
import WAFMonitorPage from "./pages/WAFMonitorPage";
import DataEnvironmentPage from "./pages/DataEnvironmentPage";
import ESignaturesPage from "./pages/ESignaturesPage";
import NotificationPreferencesPage from "./pages/NotificationPreferencesPage";
import GeoLibraryPage from "./pages/GeoLibraryPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";
import SecurityPolicyPage from "./pages/SecurityPolicyPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import DocumentControlPage from "./pages/DocumentControlPage";
import SVRPage from "./pages/SVRPage";
import ISO9001Page from "./pages/ISO9001Page";
import BrandAssetsPage from "./pages/BrandAssetsPage";
import PublicGovernancePage from "./pages/PublicGovernancePage";
import CertificateVerifyPage from "./pages/CertificateVerifyPage";
import { Toaster, toast } from "sonner";
import CharstanChatWidget from "./components/CharstanChatWidget";
import InstallPrompt from "./components/InstallPrompt";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth Context
const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

// Auth Provider
const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      setUser(response.data);
    } catch (error) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  // PR_RUN_052 — Auto-redeem pending promo code immediately after the
  // user authenticates. The flow:
  //   1. Visitor lands on /login?promo=CHARSTAN-LAUNCH (or types it in)
  //   2. LoginPage validates it via /check and persists to
  //      localStorage.pending_promo_code
  //   3. User completes SSO / password flow; AuthProvider becomes
  //      authenticated and this effect fires
  //   4. We POST /marketing/promo/redeem with the stored code
  //   5. On success → toast + clear storage; on 409 "already redeemed" →
  //      clear silently; on other errors leave the storage so the user
  //      can retry from their account settings later.
  // Guard with a ref-equivalent (sessionStorage "redeem_in_flight") so a
  // fast re-render doesn't double-fire the POST.
  useEffect(() => {
    if (!user) return;
    let stored;
    try { stored = localStorage.getItem("pending_promo_code"); } catch { return; }
    if (!stored) return;
    // De-dupe in-flight redeem attempts across re-renders.
    try {
      if (sessionStorage.getItem("promo_redeem_in_flight") === stored) return;
      sessionStorage.setItem("promo_redeem_in_flight", stored);
    } catch { /* private mode — skip the guard */ }

    (async () => {
      try {
        const res = await axios.post(
          `${API}/marketing/promo/redeem`,
          { code: stored },
          { withCredentials: true },
        );
        const { trial_days_granted, trial_expires_at_utc } = res.data || {};
        const expires = (trial_expires_at_utc || "").slice(0, 10);
        toast.success(
          `Promo applied: ${trial_days_granted || 30}-day free trial active${expires ? ` until ${expires}` : ""}.`,
          { duration: 8000 },
        );
        try { localStorage.removeItem("pending_promo_code"); } catch { /* noop */ }
        // Refresh /auth/me so the rest of the app sees the new trial state.
        try { await checkAuth(); } catch { /* noop */ }
      } catch (err) {
        const status = err?.response?.status;
        if (status === 409) {
          // User had already redeemed this code on a prior visit. Silent clear.
          try { localStorage.removeItem("pending_promo_code"); } catch { /* noop */ }
        } else if (status === 410) {
          toast.error("Your promo code has expired or been deactivated.");
          try { localStorage.removeItem("pending_promo_code"); } catch { /* noop */ }
        } else if (status === 404) {
          toast.error("Promo code not recognized.");
          try { localStorage.removeItem("pending_promo_code"); } catch { /* noop */ }
        }
        // Any other error: keep the stored code so a retry is possible.
      } finally {
        try { sessionStorage.removeItem("promo_redeem_in_flight"); } catch { /* noop */ }
      }
    })();
  }, [user, checkAuth]);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (error) {
      console.error("Logout error:", error);
    }
    setUser(null);
  };

  const value = {
    user,
    setUser,
    loading,
    logout,
    checkAuth,
    isAdmin: user?.role === "admin",
    isAuditor: user?.role === "auditor",
    isClient: user?.role === "client",
    isReader: user?.role === "reader"
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Auth Callback Component
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        
        try {
          const response = await axios.post(
            `${API}/auth/session`,
            { session_id: sessionId },
            { withCredentials: true }
          );
          
          setUser(response.data);
          // CRITICAL (AUTH-LOOP-01 fix): strip the #session_id=... fragment from
          // the URL BEFORE navigating. React Router's navigate() preserves the
          // hash by default, so without this the next render of <AppRouter/>
          // sees `location.hash.includes('session_id=')` again and re-mounts
          // <AuthCallback/>, looping the user.
          if (typeof window !== 'undefined' && window.history?.replaceState) {
            const cleanUrl = window.location.pathname + window.location.search;
            window.history.replaceState(null, '', cleanUrl);
          }
          navigate("/dashboard", { replace: true, state: { user: response.data } });
        } catch (error) {
          console.error("Auth error:", error);
          // Strip the fragment on failure too so /login does not bounce back.
          if (typeof window !== 'undefined' && window.history?.replaceState) {
            window.history.replaceState(null, '', '/login');
          }
          navigate("/login", { replace: true });
        }
      } else {
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#0A1628] flex items-center justify-center">
      <div className="text-center">
        <div className="logo-hex w-12 h-12 mx-auto mb-4 animate-pulse" />
        <p className="text-[#7EA8CC]">Authenticating...</p>
      </div>
    </div>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children, allowedRoles = [], roles = [] }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  // Accept both allowedRoles and roles props
  const effectiveRoles = allowedRoles.length > 0 ? allowedRoles : roles;

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A1628] flex items-center justify-center">
        <div className="text-center">
          <div className="logo-hex w-12 h-12 mx-auto mb-4 animate-pulse" />
          <p className="text-[#7EA8CC]">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (effectiveRoles.length > 0 && !effectiveRoles.includes(user.role)) {
    // Readers get redirected to their own dashboard, not the main one
    if (user.role === "reader") {
      return <Navigate to="/reader-dashboard" replace />;
    }
    // Clients get redirected to client portal
    if (user.role === "client") {
      return <Navigate to="/client-portal" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Public-safe guard for /standards: redirects unauthenticated users to /trust
const StandardsRouteGuard = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#0A1628] flex items-center justify-center">
        <div className="text-center">
          <div className="logo-hex w-12 h-12 mx-auto mb-4 animate-pulse" />
          <p className="text-[#7EA8CC]">Loading...</p>
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/trust" replace />;
  }
  return <StandardsPortalPage />;
};

// App Router
const AppRouter = () => {
  const location = useLocation();

  // Check URL fragment for session_id (synchronous, not in useEffect)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
    <TrialBanner />
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/upgrade" element={<UpgradePage />} />
      <Route path="/sso-setup" element={<SSOOnboardingWizard />} />
      <Route path="/readers" element={<ReaderHubLandingPage />} />
      <Route path="/readers/activate" element={<ReaderHubLandingPage />} />
      <Route path="/leitores" element={<ReaderHubLandingPage />} />
      <Route path="/leitores/ativar" element={<ReaderHubLandingPage />} />
      <Route path="/about" element={<AboutSeriesPage />} />
      <Route path="/about/pt" element={<AboutSeriesPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/security-policy" element={<SecurityPolicyPage />} />
      <Route path="/help" element={<HelpCenterPage />} />
      <Route path="/verify/:certificateId" element={<CertificateVerifyPage />} />
      
      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/capa"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <CAPAPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audits"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/documents"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <DocumentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/forms"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <DynamicFormsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/training"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <TrainingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suppliers"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SuppliersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deviations"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <DeviationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reports"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ReportsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/knowledge"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <KnowledgeCenterPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/calculators"
        element={<V11CalculatorsPage lang="en" />}
      />
      <Route
        path="/calculators/:calcId"
        element={<V11CalculatorsPage lang="en" />}
      />
      <Route
        path="/calculadoras"
        element={<V11CalculatorsPage lang="pt_br" />}
      />
      <Route
        path="/calculadoras/:calcId"
        element={<V11CalculatorsPage lang="pt_br" />}
      />
      <Route
        path="/calculators-legacy"
        element={
          <ProtectedRoute>
            <CalculatorsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/dispatch-readiness"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <DispatchReadinessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/security-audit-logs"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <SecurityAuditLogsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-explorer"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditExplorerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trial-funnel"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <TrialFunnelPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/service-tokens"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ServiceTokensPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/cases"
        element={
          <ProtectedRoute>
            <CaseStudiesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/qa"
        element={
          <ProtectedRoute>
            <QAEnginePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/knowledge-base"
        element={
          <ProtectedRoute>
            <KnowledgeBasePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scriber"
        element={
          <ProtectedRoute roles={["admin", "auditor"]}>
            <ScriberPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-conductor"
        element={
          <ProtectedRoute roles={["admin", "auditor"]}>
            <AuditConductorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/labs"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <LabsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/war-room"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <WarRoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-workflow"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditWorkflowPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/questionnaire"
        element={
          <ProtectedRoute>
            <ClientQuestionnairePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-portal"
        element={
          <ProtectedRoute>
            <ClientPortalPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gantt"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GanttChartPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/gap-assessment"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GapAssessmentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-readiness"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditReadinessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/project-closure"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ProjectClosurePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-documents"
        element={
          <ProtectedRoute>
            <ClientDocumentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-matrices"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditMatricesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quality-agreement"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <QualityAgreementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/competitor-analysis"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <CompetitorAnalysisPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/messages"
        element={
          <ProtectedRoute>
            <MessagesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-log"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AuditLogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/contacts"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ContactsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/communications"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <CommunicationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/trend-analysis"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <TrendAnalysisPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/process-capture"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ProcessCapturePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notification-settings"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <NotificationSettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notification-log"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <NotificationLogPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/enterprise-sso"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EnterpriseSSOPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-types"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ClientTypesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/connectors"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ConnectorsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/improvement"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ImprovementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sentinel"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SentinelPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-warroom"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditWarRoomPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/report-loader"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ReportLoaderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/defense-scripts"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <DefenseScriptPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stat-explainer"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <StatExplainerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sdvr"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SDVRPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lifecycle"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <LifecyclePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/auditors-brain"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AuditorsBrainPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/publishing"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <PublishingPortalPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reader/:bookId"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <EBookReaderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reader-dashboard"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ReaderDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/access-codes"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AdminCodeGeneratorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/qr-codes"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <AdminQRCodesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/brand-assets"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <BrandAssetsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/compliance"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ComplianceNavigatorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/document-bridge"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <DocumentBridgePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scar"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SCARManagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supplier-scorecard"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SupplierScorecardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/capa-prevention"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <CAPAPreventionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/regulatory-radar"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <RegulatoryRadarPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <UsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/projects"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <ProjectsPage />
          </ProtectedRoute>
        }
      />
      
      {/* M5 P2B Routes */}
      <Route
        path="/redaction"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <RedactionPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scriber-disclosures"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ScriberDisclosuresPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sso-providers"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <SSOProvidersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/vendor-registration"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <VendorRegistrationPage />
          </ProtectedRoute>
        }
      />
      
      {/* M6 P3 Readiness Routes */}
      <Route
        path="/analytics"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <AnalyticsChartsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/scar-escalation"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SCARescalationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/compliance-dashboard"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ComplianceDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/standards"
        element={<StandardsRouteGuard />}
      />
      <Route
        path="/trust"
        element={<TrustCenterPage />}
      />
      <Route
        path="/soa"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SoAMatrixPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/governance"
        element={<PublicGovernancePage />}
      />
      <Route
        path="/governance/center"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GovernanceCenterPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/governance/:documentId"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GovernanceDocumentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/governance-controls"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GovernanceControlsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/regional-obligations"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <RegionalObligationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/governance-assessments"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GlobalGovernanceAssessmentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/remediation-tracker"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <RemediationTrackerPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/governance-readiness"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GovernanceReadinessPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/governance-library"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GovernanceLibraryPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding-checklist"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor", "client"]}>
            <OnboardingChecklistPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client-onboarding"
        element={
          <ProtectedRoute allowedRoles={["client", "admin", "auditor"]}>
            <ClientOnboardingDashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/onboarding-review/:runId"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ClientOnboardingReviewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <NotificationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/qa-supervisor"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <QASupervisorPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/guide/:role"
        element={
          <ProtectedRoute>
            <GuidePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/organizations"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <CRMOrganizationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/organizations/:orgId"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <CRMOrganizationDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/crm/support-tickets"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SupportTicketsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/my-support"
        element={
          <ProtectedRoute>
            <MySupportPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/predictive-intelligence"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <PredictiveIntelligencePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/annex11-readiness"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <Annex11ReadinessPage />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/payments"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <PaymentsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/platform-health"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <PlatformHealthPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/waf-monitor"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <WAFMonitorPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/data-environment"
        element={
          <ProtectedRoute allowedRoles={["admin"]}>
            <DataEnvironmentPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/esignatures"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ESignaturesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/settings/notifications"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor", "client"]}>
            <NotificationPreferencesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/doc-control"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <DocumentControlPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/geo-library"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <GeoLibraryPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/svr"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <SVRPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/iso9001"
        element={
          <ProtectedRoute allowedRoles={["admin", "auditor"]}>
            <ISO9001Page />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <AuthenticatedChatWidget />
    <InstallPrompt />
    </>
  );
};

// Render chat widget only when user is authenticated
const AuthenticatedChatWidget = () => {
  const { user, loading } = useAuth();
  if (loading || !user) return null;
  return <CharstanChatWidget />;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { background: '#1A1D27', border: '1px solid rgba(255,255,255,0.08)', color: '#fff' },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;

// Export API URL for use in other components
export { API, BACKEND_URL };
